<template>
  <div class="LayoutHolder" id="PageTop">
    <header class="Header">
      <div class="Container">
        <div class="BoxWide">
          <div class="Logo">
            <div class="Logo"><a href="/" title="Home"><img src="../src/assets/images/Spacer.png" alt="" /></a></div>
          </div>
          <div class="Button BackButton"><a href="http://igot.nubess.net/">Torna al sito IGot</a></div>
        </div>
      </div>
    </header>
    <section class="Section">
			<div class="Container">
				<div class="BoxWide">
					<div class="MainText">
						<div class="Index">UN PASSO ALLA VOLTA - VIVERE MEGLIO</div>
						<div class="Editor">
							<h1>Sei pronto a metterti in forma e vivere meglio?</h1>
							<p>Durante il primo incontro viene presentato il progetto IGOT, viene approfondita la condizione generale del paziente e vengono fornite tutte le informazioni pratiche e generali, necessarie per affrontare al meglio l’intero percorso. </p>
						</div>
					</div>
				</div>
			</div>
		</section>
    <router-view/>
    <footer class="Footer">
      <div class="Container">
        <div class="BoxWide">
          <div class="AddressBox">
            <div class="FooterLogo">
              <div class="FooterLogo"><a href="/" title="Home"><img src="../src/assets/images/Spacer.png" alt="" /></a></div>
            </div>
            <div class="FooterAddress">Via Nomedellavia 1234 – 98765 Località/Città</div>
            <div class="FooterMail">Info@emailaddress.com</div>
          </div>
        </div>
        <div class="BoxWide">
          <div class="StrokedSeparator">&nbsp;</div>
          <div class="FooterMenu">
            <ul>
              <li><a :href="this.url_Privacy">Privacy Policy</a></li>
              <li><a :href="this.url_Terms">Therms &amp; Conditions</a></li>
              <li><a :href="this.url_Notes">Legal Notes</a></li>
              <li><a :href="this.url_Credits">Credits</a></li>
            </ul>
          </div>
          <div class="FooterSocial">
            <ul>
              <li><a href="error"><img src="../src/assets/images/SocialBottom/FacebookRedIcon.png"  srcset="../src/assets/images/SocialBottom/FacebookRedIconRetina.png 2x" alt="" /></a></li>
              <li><a href="error"><img src="../src/assets/images/SocialBottom/LinkedinRedIcon.png"  srcset="../src/assets/images/SocialBottom/LinkedinRedIconRetina.png 2x" alt="" /></a></li>
              <li><a href="error"><img src="../src/assets/images/SocialBottom/TwitterRedIcon.png"  srcset="../src/assets/images/SocialBottom/TwitterRedIconRetina.png 2x" alt="" /></a></li>
            </ul>
          </div>
        </div>
        <div class="BoxWide">
          <div class="Copyright">Copyright 2024 ©. Tutti i diritti riservati.</div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data(){
    return{
      url: process.env.VUE_APP_BASE_SITE_URL,
      url_Privacy: process.env.VUE_APP_PRIVACY_URL,
      url_Terms: process.env.VUE_APP_TERMS_URL,
      url_Notes: process.env.VUE_APP_NOTES_URL,
      url_SalesCond: process.env.VUE_APP_SALES_COND_URL,
      url_UePolicy: process.env.VUE_APP_UE_POLICY_URL,
      url_Credits: process.env.VUE_APP_CREDITS_URL
    }
  }
  /*
  created(){
    this.$store.dispatch({
      type: "getCentriMedici",
      datiCentri: null
    });
  }*/
  
}
</script>

<style>
.BookingNavButton{
	text-decoration: none !important;
}
</style>
